import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    color?: string;
    width?: number;
    height?: number;
};

export const ChevronDownIcon = (props: Props) => {
    const { color = 'currentColor', width = 26, height = 16, ...rest } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M26 3.09834L23.2122 8.92149e-07L13.3972 9.56944L2.80222 0L0 3.09833L13.3828 15.1883L26 3.09834Z" fill={color} />
        </svg>
    );
};
